// document.addEventListener('DOMContentLoaded', function () {
//   const params = new URLSearchParams(window.location.search);

//   if (window.abtest_variation === '1' || params.get('abtest_variation') === '1') {

//     const sectionId = 'template--19626650992780__main';
//     const productUrl = '/products/hair-growth-serum-for-men-and-women';
//     console.log("hello", `${productUrl}?sections=${sectionId}`);
//     fetch(`${productUrl}?sections=${sectionId}`)
//       .then(res => res.json())
//       .then(data => {
//         const html = data[sectionId];

//         const container = document.querySelector(`#shopify-section-${sectionId}`);

//         if (container && html) {
//           container.innerHTML = html;

//           // ✅ alert AFTER replacement

//         } else {
//           console.error('Container or HTML not found');
//         }
//       })
//       .catch(err => console.error('Error:', err));
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
 const modal = document.querySelector('.product-media-modal');
const whatsapp = document.querySelector('#sy-whatshelp');

if (!modal || !whatsapp) return;

const observer = new MutationObserver(() => {
if (modal.hasAttribute('open')) {
whatsapp.style.zIndex = '1';
whatsapp.style.opacity = '0';
} else {
whatsapp.style.zIndex = '9999';
whatsapp.style.opacity = '1';
 }
});

 observer.observe(modal, {
  attributes: true,
  attributeFilter: ['open']
});
});

// document.addEventListener("DOMContentLoaded", function () {
//   if (!document.querySelector(".mySwiper")) return;
//   setTimeout(function () {
//     new Swiper(".mySwiper", {
//       slidesPerView: 1,
//       loop: true,
//       spaceBetween: 5,
//       autoplay: {
//         delay: 9000,
//         disableOnInteraction: false
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev"
//       }
//     });

//   }, 1200);

// });

// Mobile: show Premium Blog before Hair Routine (swap section order on mobile only)
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 750) return;
  var hairRoutine = document.querySelector('[id$="__featured_collection_tab_YmMQHA"]');
  var blog = document.querySelector('[id$="__page_YABDkH"]');
  if (hairRoutine && blog) {
    hairRoutine.parentNode.insertBefore(blog, hairRoutine);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var slideshowContainers = document.querySelectorAll(".mySwiper.septrate-collection-container");
  if (!slideshowContainers.length) return;

  setTimeout(function () {
    var scrollY = window.scrollY;

    // Actively block any scroll that fires during Swiper init (loop cloning / focus)
    function lockScroll() { window.scrollTo(0, scrollY); }
    window.addEventListener('scroll', lockScroll);

    slideshowContainers.forEach(function (container) {
      var slideCount = container.querySelectorAll(".swiper-slide").length;
      if (slideCount < 1) return;

      var paginationEl = container.querySelector(".slideshow-main-pagination");
      var nextEl = container.querySelector(".swiper-button-next");
      var prevEl = container.querySelector(".swiper-button-prev");
      var loopEnabled = slideCount > 1;

      var swiper = new Swiper(container, {
        slidesPerView: 1,
        loop: loopEnabled,
        spaceBetween: 5,
        a11y: false,
        autoplay: loopEnabled ? {
          delay: 9000,
          disableOnInteraction: false
        } : false,
        navigation: nextEl && prevEl ? {
          nextEl: nextEl,
          prevEl: prevEl
        } : undefined
      });

      if (!paginationEl) return;

      var bullets = paginationEl.querySelectorAll(".swiper-pagination-bullet");
      if (!bullets.length) return;

      function setActiveBullet(activeIndex) {
        bullets.forEach(function (bullet, index) {
          var isActive = index === activeIndex;
          bullet.classList.toggle("swiper-pagination-bullet-active", isActive);
          bullet.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      }

      function goToSlide(index) {
        if (loopEnabled && typeof swiper.slideToLoop === "function") {
          swiper.slideToLoop(index);
        } else {
          swiper.slideTo(index);
        }
      }

      bullets.forEach(function (bullet, index) {
        bullet.addEventListener("click", function () {
          goToSlide(index);
        });
      });

      swiper.on("realIndexChange", function () {
        setActiveBullet(swiper.realIndex);
      });

      setActiveBullet(swiper.realIndex);
    });

    // Release scroll lock after two frames (enough for all async DOM work to settle)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.removeEventListener('scroll', lockScroll);
      });
    });

  }, 1200);

});

var i,
  coll = document.getElementsByClassName("collapsible");
for (i = 0; i < coll.length; i++)
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var e = this.nextElementSibling;
    "block" === e.style.display
      ? (e.style.display = "none")
      : (e.style.display = "block");
  });
// function myFunction() {
//   var e = document.getElementById("myDIV");
//   "Read More" === e.innerHTML
//     ? (e.innerHTML = "Read Less")
//     : (e.innerHTML = "Read More");
// }
(() => {
  let e = document.querySelectorAll(".counter"),
    t = Array.from(e);
  t.map((e) => {
    let t = e.textContent,
      n = 1,
      l = e.dataset.speed / t;
    function a() {
      (e.textContent = n++), t < n && clearInterval(o);
    }
    let o = setInterval(() => {
      a();
    }, l);
  });
})(),
  $(".read-more").click(function () {
    $(".product__description.rte").toggleClass("ace");
  });

document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector(".marquee-offer-text div");
  let startPosition = content?.offsetWidth;
  function animateMarquee() {
    if (startPosition <= -content?.offsetWidth / 2) {
      startPosition = content?.offsetWidth;
    }
    content.style.transform = `translateX(${startPosition}px)`;
    startPosition -= 1; // Adjust speed here
    requestAnimationFrame(animateMarquee);
  }
  if (content) animateMarquee();
});

// new PDP design js

// swiper slider
document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".paralasss")) return;

  var swiper = new Swiper(".paralasss", {
    speed: 600,
    parallax: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1, // Default
    spaceBetween: 0, // Default
    watchSlidesProgress: true, // Important for parallax + breakpoints
    breakpoints: {
      320: {
        // Mobile
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        // Tablet
        slidesPerView: 1,
        spaceBetween: 20,
      },
      1024: {
        // Desktop
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });
});

// Ingredient swiper slider
document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".ingredient")) return;

  var swiper = new Swiper(".ingredient", {
    speed: 600,
    parallax: true,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 1, // Default
    spaceBetween: 0, // Default
    watchSlidesProgress: true, // Important for parallax + breakpoints
    breakpoints: {
      320: {
        // Mobile
        slidesPerView: 2.1,
        spaceBetween: 10,
      },
      640: {
        // Tablet
        slidesPerView: 3,
        spaceBetween: 10,
      },
      940: {
        // Tablet
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        // Desktop
        slidesPerView: 3.1,
        spaceBetween: 10,
      },
    },
  });
});

// accordian
var acc = document.getElementsByClassName("accordion");
var r;

for (r = 0; r < acc.length; r++) {

  acc[r].addEventListener("click", function () {

    var panel = this.nextElementSibling;

    // Find parent faq wrapper
    var wrapper = this.closest(".faqs-content");

    // ONLY for one-open-accordion
    if (wrapper && wrapper.classList.contains("one-open-accordion")) {

      var allAccordions = wrapper.getElementsByClassName("accordion");

      for (var i = 0; i < allAccordions.length; i++) {

        if (allAccordions[i] !== this) {

          allAccordions[i].classList.remove("active");

          var otherPanel = allAccordions[i].nextElementSibling;

          if (otherPanel) {
            otherPanel.style.display = "none";
          }
        }
      }
    }

    // Toggle current
    this.classList.toggle("active");

    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }

  });

}

// tabs

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;

  // Hide all tabcontent
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove 'active' class from all tablinks
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show current tab and set active
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.classList.add("active");
}


function openScienceTab(evt, tabId) {
  var i, tabcontent, tablinks;

  // Hide all science tab contents
  tabcontent = document.getElementsByClassName("tabcontent-science");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Remove active class from buttons inside this section only
  tablinks = document.querySelectorAll(".Science-Behind .tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show selected tab
  document.getElementById(tabId).style.display = "block";
  evt.currentTarget.classList.add("active");
}

// append class on body

document.addEventListener("DOMContentLoaded", function () {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const class1 = pathSegments[0];
  const class2 = pathSegments[1];
  if (class1 && class2) {
    document.body.classList.add(`url-${class1}`, `url-${class2}`);
  }
});




// Custom code to pass the value of quantity selector to the sticky ATC button form            
function passValue(val) {
  let updatedQuantity = val;
  const stickyInput = document.querySelector('[data-quantity-input="sticky_cart"]');
  if (stickyInput) stickyInput.value = updatedQuantity;
}
// Custom code to pass the value of quantity selector to the sticky ATC button form ends here



// varient title update 




(function () {
  document.addEventListener('DOMContentLoaded', function () {
    function updateVariantTitle(variantId) {
      if (!variantId || !displayVariantTitle[variantId]) {
        return;
      }
      const newTitle = displayVariantTitle[variantId];
      const metafieldElement = document.querySelector('.custom-metafield');
      if (metafieldElement) {
        metafieldElement.innerHTML = newTitle;
      }
      //const richTextHeading = document.querySelector('h2.rich-text__heading');
      const richTextHeading = document.querySelector('.rich-text__heading');
      if (richTextHeading) {
        richTextHeading.innerHTML = newTitle;
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches('variant-selects select, variant-selects input, input[name="id"], select[name="id"]')) {
        const variantId = e.target.value || document.querySelector('input[name="id"]')?.value;

        if (variantId) {
          updateVariantTitle(variantId);
        }
      }
    });
    document.addEventListener('variant:change', function (e) {
      const variantId = e.detail?.variant?.id || e.detail?.id;
      if (variantId) {
        updateVariantTitle(variantId);
      }
    });
  });
})();
/* Commented to make major changes starts By Ms*/
/*(function () {
  document.addEventListener('DOMContentLoaded', function () {
    async function updateSectionFromVariant() {
      // Get variantId from modal DOM
      const modalContent = document.querySelector('.quick-add-modal__content-info');
      const variantSpan = modalContent?.querySelector('span.option-value-name[data-product-varinat]');
      const variantId = variantSpan?.getAttribute('data-product-varinat');

      if (!variantId) {
        console.warn('Variant ID not found.');
        return;
      }

      // Get all product-info sections on the page
      const productInfoSections = document.querySelectorAll('.my-product-page product-info[data-section]');

      if (productInfoSections.length === 0) {
        console.warn('No product-info sections found.');
        return;
      }

      console.log('Updating sections for variant:', variantId);

      for (const productInfoEl of productInfoSections) {
        const sectionId = productInfoEl.getAttribute('data-section');
        if (!sectionId) {
          console.warn('Section ID missing on a product-info element.');
          continue;
        }

        try {
          // Fetch the updated section HTML
          const response = await fetch(window.location.pathname + `?section_id=${sectionId}&variant=${variantId}`);
          if (!response.ok) throw new Error('Network response was not ok');

          const htmlText = await response.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = htmlText;

          // Find the updated product-info section in the response
          const newContent = tempDiv.querySelector(`.my-product-page product-info[data-section="${sectionId}"]`);

          if (newContent) {
            productInfoEl.replaceWith(newContent);
            console.log(`Section ${sectionId} updated.`);
          } else {
            console.warn(`Updated section ${sectionId} not found in response.`);
          }
        } catch (error) {
          console.error(`Error updating section ${sectionId}:`, error);
        }
      }
    }

    // Listen for variant changes
    document.addEventListener('change', function (e) {
      if (e.target.matches('variant-selects select, variant-selects input, input[name="id"], select[name="id"]')) {
        updateSectionFromVariant();
      }
    });

    document.addEventListener('variant:change', function () {
      updateSectionFromVariant();
    });

    // MutationObserver to detect when .my-product-page product-info sections are added dynamically
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          for (const node of addedNodes) {
            if (node.matches && node.matches('.my-product-page product-info[data-section]')) {
              console.log('Detected new product-info section added to DOM');
              updateSectionFromVariant();
            }
          }
        }
      }
    });

    // Start observing the whole document body for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();*/
/* Commented to make major changes ends By Ms*/


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Tracks last variant ID used so MutationObserver can re-apply the same one
    let lastVariantId = null;

    async function updateSectionFromVariant(variantId) {
      if (!variantId) {
        console.warn('Variant ID not found.');
        return;
      }

      const productInfoSections = document.querySelectorAll('.my-product-page product-info[data-section]');
      if (productInfoSections.length === 0) {
        console.warn('No product-info sections found.');
        return;
      }

      console.log('Updating sections for variant:', variantId);
      lastVariantId = String(variantId);

      try {
        for (const productInfoEl of productInfoSections) {
          // Skip if this section is inside the modal itself
          if (productInfoEl.closest('.quick-add-modal__content-info')) continue;

          const sectionId = productInfoEl.getAttribute('data-section');
          if (!sectionId) continue;

          try {
            const response = await fetch(window.location.pathname + `?section_id=${sectionId}&variant=${variantId}`);
            if (!response.ok) throw new Error('Network response was not ok');
            const htmlText = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlText;
            const newContent = tempDiv.querySelector(`.my-product-page product-info[data-section="${sectionId}"]`);
            if (newContent) {
              // Mark as self-inserted so MutationObserver skips it and doesn't re-trigger
              newContent.setAttribute('data-self-inserted', 'true');
              productInfoEl.replaceWith(newContent);
              console.log(`Section ${sectionId} updated.`);
            } else {
              console.warn(`Updated section ${sectionId} not found in response.`);
            }
          } catch (error) {
            console.error(`Error updating section ${sectionId}:`, error);
          }
        }

        // After section update from modal: switch sticky ATC from popup mode → direct-atc mode
        // so next click directly adds to cart instead of reopening the popup.
        document.querySelectorAll('.select-updated-variant[data-variant-id]').forEach(btn => {
          btn.setAttribute('data-variant-id', String(variantId));
        });
        // Force currentVariantIndex (defined in product-popup.liquid) to direct-atc mode (>= 2)
        if (typeof currentVariantIndex !== 'undefined' && typeof updateATCVisibility === 'function') {
          currentVariantIndex = 99;
          updateATCVisibility();
        }
      } catch (e) {
        console.error('updateSectionFromVariant error:', e);
      }
    }

    // IMPORTANT: Only trigger section update when the event originates from INSIDE the modal.
    // Main-page variant changes are handled by Shopify's own product-info.js — we must not
    // replace the section for those or it disrupts the scroll-popup flow.
    function isFromModal(target) {
      return !!(target && target.closest('.quick-add-modal, .quick-add-modal__content-info'));
    }

    document.addEventListener('change', function (e) {
      if (!isFromModal(e.target)) return;
      if (e.target.matches('input[name="id"], select[name="id"]')) {
        updateSectionFromVariant(e.target.value);
      }
    });

    document.addEventListener('variant:change', function (e) {
      if (!isFromModal(e.target)) return;
      const variantId = e.detail?.variant?.id || e.detail?.id || null;
      if (variantId) updateSectionFromVariant(String(variantId));
    });

    // MutationObserver — only for externally injected sections, not our own replaceWith() calls.
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.matches && node.matches('.my-product-page product-info[data-section]')) {
              // Skip nodes we inserted ourselves
              if (node.getAttribute('data-self-inserted') === 'true') {
                node.removeAttribute('data-self-inserted');
                continue;
              }
              console.log('Detected new product-info section added to DOM');
              if (lastVariantId) updateSectionFromVariant(lastVariantId);
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();



// custom code for quantity 
document.addEventListener('DOMContentLoaded', function () {
  let previousValue = 1;

  function syncInputs(value, container = document) {
    container.querySelectorAll('input#quantity__input[type=hidden][name="quantity"]').forEach(function (input) {
      input.value = value;
      input.setAttribute('value', value);
    });
  }

  function renderQuantitySyncFunctionality(container = document) {
    const visibleInputs = container.querySelectorAll('product-info input.quantity__input[type=number]');
    if (!visibleInputs || visibleInputs.length === 0) {
      console.log("No visible inputs found");
      return;
    }

    visibleInputs.forEach(visibleInput => {
      // Sync initially
      const value = parseInt(visibleInput.value) || 1;
      syncInputs(value, container);
      previousValue = value;

      // Attach listener only once
      if (!visibleInput._hasChangeListener) {
        visibleInput.addEventListener('change', function () {
          const val = parseInt(this.value) || 1;
          syncInputs(val, container);
          previousValue = val;
        });
        visibleInput._hasChangeListener = true;
      }

      // Variant change listener: attach if not attached yet
      let variantSelect = container.querySelector('variant-selects');
      if (variantSelect && !variantSelect._hasChangeListener) {
        variantSelect.addEventListener('change', function () {
          visibleInput.value = 1;
          visibleInput.dispatchEvent(new Event('change'));
        });
        variantSelect._hasChangeListener = true;
      }
    });
  }

  function resetQuantityToOne() {
    const visibleInput = document.querySelector('product-info input.quantity__input[type=number]');
    if (!visibleInput) return;
    visibleInput.value = 1;
    visibleInput.dispatchEvent(new Event('change'));
    syncInputs(1);
    previousValue = 1;
  }

  // Delegate submit event on document for dynamic forms
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (form && form.tagName.toLowerCase() === 'form') {
      // For add-to-cart forms, DON'T reset yet - wait for cartUpdate event
      if (form.getAttribute('data-type') === 'add-to-cart-form') {
        return; // Skip resetting - price stays multiplied during submission
      }
      resetQuantityToOne();
    }
  });

  // Reset quantity ONLY AFTER successful cart update (not during submission)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(() => {
        resetQuantityToOne();
      }, 300);
    });
  }

  // Initial render
  renderQuantitySyncFunctionality();

  // Quick-add modal handling - FIXED
  document.addEventListener('click', function (event) {
    if (event.target.closest('.quick-add__submit')) {
      console.log("Quick-add button clicked");
      setTimeout(() => {
        console.log("Re-initializing after modal");
        renderQuantitySyncFunctionality();
      }, 1500); // Reduced timeout to 500ms
    }
  });

  // Re-initialize on Shopify section reloads
  document.addEventListener('shopify:section:load', function () {
    console.log("Section reloaded, re-initializing");
    setTimeout(() => {
      renderQuantitySyncFunctionality();
    }, 100);
  });
});


function startTimer(seconds, el) {

  let remaining = seconds;
  let interval;

  const tick = () => {
    const h = String(Math.floor(remaining / 3600)).padStart(2, '0');
    const m = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    const s = String(remaining % 60).padStart(2, '0');
    el.textContent = `${h}h ${m}m ${s}s`;

    if (remaining > 0) {
      remaining--;
    } else {
      const timerBar = el.closest('.oc-timer-bar');
      if (timerBar) timerBar.style.display = 'none';

      clearInterval(interval);
    }

  };

  if (!el) return;
  tick();
  interval = setInterval(tick, 1000);
}

function scrollSelectedVariantIntoView() {
  const containers = document.querySelectorAll(
    '.product-form__input--pill.variants, .product-form__input--pill.size'
  );

  containers.forEach(container => {
    const checkedInput = container.querySelector(
      'input[type="radio"]:checked'
    );
    if (!checkedInput) return;

    const labels = container.querySelectorAll(
      `label[for="${checkedInput.id}"]`
    );

    const label = [...labels].find(l => {
      const r = l.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
    if (!label) return;

    const isSize = container.classList.contains('size');
    const sizePeek = isSize ? 48 : 16;

    const containerRect = container.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();

    let targetRect = labelRect;

    // ONLY for VARIANTS → NEXT logic
    if (!isSize) {
      const visibleLabels = [...container.querySelectorAll('label')].filter(l => {
        const r = l.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });

      const index = visibleLabels.indexOf(label);
      const nextLabel = visibleLabels[index + 1];
      if (nextLabel) {
        targetRect = nextLabel.getBoundingClientRect();
      }
    }

    const offsetLeft =
      targetRect.left - containerRect.left + container.scrollLeft;
    const offsetRight = offsetLeft + targetRect.width;

    const visibleLeft = container.scrollLeft;
    const visibleRight = visibleLeft + container.clientWidth;

    // 🔹 LEFT cut (with peek)
    if (offsetLeft < visibleLeft + sizePeek) {
      container.scrollLeft = offsetLeft - sizePeek;
    }
    // 🔹 RIGHT cut (with peek)
    else if (offsetRight > visibleRight - sizePeek) {
      container.scrollLeft =
        offsetRight - container.clientWidth + sizePeek;
    }
  });
}




function runTimerScript() {
  startObserver();
  if (!document.querySelector('.oc-timer-bar')) return;

  const bars = document.querySelectorAll('.oc-timer-bar');

  bars.forEach(bar => {

    if (bar.dataset.inited === 'true') return;

    const endTime = bar.getAttribute('data-timer-ends-at');
    const countdownEl = bar.querySelector('.timer-countdown');
    if (!countdownEl) return;

    const endDate = new Date(endTime);
    const seconds = Math.floor((endDate - new Date()) / 1000);

    if (seconds > 0) {
      startTimer(seconds, countdownEl);
    }
    bar.dataset.inited = 'true';
  });
}

document.addEventListener("DOMContentLoaded", runTimerScript);
document.addEventListener("change", runTimerScript, true);
document.addEventListener('shopify:section:load', runTimerScript, true);
function startObserver() {
  if (!document.body) {
    return setTimeout(startObserver, 50);
  }

  const observer = new MutationObserver(() => {
    const specialTimer = document.querySelector('.oc-timer-bar');
    if (specialTimer && !specialTimer.dataset.timerRan) {
      specialTimer.dataset.timerRan = "true";
      runTimerScript();
    }
  });
  // NOW body definitely exists → no error
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

}


// // Declare variables in outer scope so all functions can access them ATC AB Testing
//  let qty, mobileTarget, originalParent, originalNextSibling;

// // // --- MOVE QUANTITY FUNCTION ---
// function moveQuantity() {
//   const scope = document.querySelector('.my-product-page');
//   if (!scope) return;
//   qty = document.querySelector('.product-form__quantity');
//   mobileTarget = document.querySelector('.custom-oc-move-atc');
//   if (!qty || !mobileTarget) return;

//   // Detect current placement
//   const onMobile = window.innerWidth < 767;

//   const isAlreadyInMobile = mobileTarget.contains(qty);
//   const isAlreadyInDesktop = !onMobile && !mobileTarget.contains(qty);

//   // --- SHORT-CIRCUIT LOGIC ---
//   // If on mobile and qty is already inside mobileTarget → do nothing
//   if (onMobile && isAlreadyInMobile) return;

//   // If on desktop and qty is already back in originalParent → do nothing
//   if (!onMobile && isAlreadyInDesktop) return;

//   // Continue only if movement is REALLY required
//   originalParent = qty.parentNode;
//   originalNextSibling = qty.nextElementSibling;

//   if (onMobile) {

//     mobileTarget.prepend(qty);
//     qty.classList.remove('oc-custom-quantity-hidden')

//   } else {
//     // Move to desktop
//     if (originalNextSibling) {
//       originalParent.insertBefore(qty, originalNextSibling);
//     } else {
//       originalParent.appendChild(qty);
//     }
//   }
// }


// // --- OBSERVER FOR TIMER ---
// function startObserver() {
//   const body = document.body;
//   if (!body) return setTimeout(startObserver, 50);

//   const observer = new MutationObserver(() => {
//     moveQuantity();
//   });

//   observer.observe(body, { childList: true, subtree: true });
// }

// // --- PAGE READY ---
// document.addEventListener('DOMContentLoaded', function () {
//   qty = document.querySelector('.product-form__quantity');
//   mobileTarget = document.querySelector('.custom-oc-move-atc');
//   if (!qty || !mobileTarget) return;



//   // Start observer after DOM ready
//   startObserver();

//   // Move qty once on load
//   moveQuantity();
//   // Move again when screen resizes
//   window.addEventListener('resize', moveQuantity);
// });

//  custom code for quantity input in cart drawer
document.addEventListener("keydown", function (e) {
  const drawer = e.target.closest("cart-drawer");
  const qtyInput = e.target;

  if (
    drawer &&
    qtyInput.classList.contains("quantity__input") &&
    e.key === "Enter"
  ) {
    e.preventDefault();
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
});

// Sticky mobile category menu:  Page load par active category ko center me scroll karne ke liye
(function () {

  function scrollToActiveChip() {
    const container = document.querySelector('.sticky-mobile-menu-section');
    if (!container) return;

    const activeChip = container.querySelector('.mobile-category--active');
    if (!activeChip) return;

    const chipLeft = activeChip.offsetLeft;
    const chipWidth = activeChip.offsetWidth;
    const containerWidth = container.clientWidth;

    container.scrollLeft = chipLeft - (containerWidth / 2) + (chipWidth / 2);
  }

  document.addEventListener('DOMContentLoaded', scrollToActiveChip);
  window.addEventListener('load', scrollToActiveChip);

})();

/* Clear Wizzy search input on focus (only if search exists) */

if (document.querySelector(".wizzy-search-input")) {
  document.addEventListener("focusin", function (e) {
    if (e.target.classList.contains("wizzy-search-input")) {
      e.target.value = "";
    }
  });
}